// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_ReconnectDeviceResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/devices_franquias/reconnect_device
 *
 * Action endpoint — confirmation only; envelope `dados` is null.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type DevicesFranquias_ReconnectDeviceResponseDados = null;

export type DevicesFranquias_ReconnectDeviceResponse = ApiResponse<DevicesFranquias_ReconnectDeviceResponseDados>;

registerResponseContract('DevicesFranquias_ReconnectDeviceResponse', {})
